
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24.236 20.196"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M5.886 4.039a3.032 3.032 0 01-2.857 2.02A3.031 3.031 0 010 3.03 3.031 3.031 0 013.029 0a3.032 3.032 0 012.857 2.02h13.805a4.546 4.546 0 014.544 4.544 4.546 4.546 0 01-4.544 4.544h-4.717a3.032 3.032 0 01-2.857 2.02 3.032 3.032 0 01-2.857-2.02H4.543a2.525 2.525 0 00-2.525 2.525 2.525 2.525 0 002.525 2.525h13.805a3.032 3.032 0 012.857-2.02 3.031 3.031 0 013.029 3.029 3.031 3.031 0 01-3.029 3.029 3.032 3.032 0 01-2.857-2.02H4.543a4.546 4.546 0 01-4.544-4.544 4.546 4.546 0 014.544-4.544H9.26a3.032 3.032 0 012.857-2.02 3.032 3.032 0 012.857 2.02h4.717a2.525 2.525 0 002.525-2.525 2.525 2.525 0 00-2.525-2.525zm6.232 5.049a1.01 1.01 0 011.01 1.01 1.01 1.01 0 01-1.01 1.01 1.01 1.01 0 01-1.01-1.01 1.01 1.01 0 011.01-1.01z"}})])
          )
        }
      }
    